/*
*@Author: dcl
*@Description: 分支机构页面
*@Date: 2022-11-14 11:27:12
*/
<template>
<div class="ibr">
    <el-table class="eltable" :data="companyList" height="500" :header-cell-style="headerstyle" :cell-style="cellStyle" style="width: 95%">
        <el-table-column prop="name" label="分支结构名称" min-width="100" align="center">
            <template slot-scope="scope">
                <div>{{ scope.row.name }}</div>
                <div @click="changehb" class="table-a">
                    {{ scope.row.a && scope.row.a }}
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="addr" label="办公地址" align="center" min-width="130"></el-table-column>
        <el-table-column prop="tel" label="联系电话" min-width="70" align="center"></el-table-column>
    </el-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            companyList: [{
                    id: 1,
                    name: "东风南方保险代理有限公司 辽宁分公司",
                    addr: "辽宁省沈阳市沈河区东陵路36号",
                    tel: "024-88459198"
                },
                {
                    id: 2,
                    name: "东风南方保险代理有限公司 北京分公司",
                    addr: "北京市大兴区黄村镇清源路40号1幢平房",
                    tel: "010-53792755"
                },
                {
                    id: 3,
                    name: "东风南方保险代理有限公司 河北分公司",
                    addr: "河北省石家庄市桥西区振岗路156号石家庄市汽车贸易园桥西区销售中心（南区）D5-B号二层",
                    tel: "0311-68099798",
                    a: '分公司信息披露'
                },
                {
                    id: 4,
                    name: "东风南方保险代理有限公司 山西分公司",
                    addr: "晋中开发区鸣李汽贸园（汇盛日产汽车服务公司）",
                    tel: "0354-2465335"
                },
                {
                    id: 5,
                    name: "东风南方保险代理有限公司 山东分公司",
                    addr: "济宁高新区327国道北、同济大道东东风日产东源专营店",
                    tel: "0537-2989003"
                },
                {
                    id: 6,
                    name: "东风南方保险代理有限公司 浙江分公司",
                    addr: "浙江省杭州市拱墅区半山街道北秀街455号（拥铁和光仓储中心）2幢2-2",
                    tel: "0571-56036685"
                },
                {
                    id: 7,
                    name: "东风南方保险代理有限公司 江苏分公司",
                    addr: "扬州市邗江区荷叶东路160号1",
                    tel: "0514-80971700"
                },
                {
                    id: 8,
                    name: "东风南方保险代理有限公司 广州分公司",
                    addr: "广州市天河区博汇街6号3栋110房-1",
                    tel: "020-66357638"
                },
                {
                    id: 9,
                    name: "东风南方保险代理有限公司 东莞分公司",
                    addr: "广东省东莞市南城街道莞太路南城段383号",
                    tel: "0769-22985916"
                },
                {
                    id: 10,
                    name: "东风南方保险代理有限公司 深圳分公司",
                    addr: "深圳市福田区福田街道福南社区福明路42号福华多层停车库701",
                    tel: "0755-86112327"
                },
                {
                    id: 11,
                    name: "东风南方保险代理有限公司 云南分公司",
                    addr: "云南省昆明市五华区二环西路559号",
                    tel: "0871-68327333"
                },
                {
                    id: 12,
                    name: "东风南方保险代理有限公司 贵州分公司",
                    addr: "贵州省贵阳市南明区花溪大道北段448号众福家园裙楼半负2层2A号房【湘雅社区】",
                    tel: "0851-83759701"
                },
                {
                    id: 13,
                    name: "东风南方保险代理有限公司 四川分公司",
                    addr: "成都市双流区东升街道龙桥路188号2栋1层1号",
                    tel: "028-85688818"
                },
                {
                    id: 14,
                    name: "东风南方保险代理有限公司 重庆分公司",
                    addr: "重庆市九龙坡区石新路220号附1号",
                    tel: "023-68881350"
                },
                {
                    id: 15,
                    name: "东风南方保险代理有限公司 海南分公司",
                    addr: "海南省海口市美兰区琼山大道292号东方日产展厅",
                    tel: "0898-65961304"
                },
                {
                    id: 16,
                    name: "东风南方保险代理有限公司 上海分公司",
                    addr: "浦东新区航头镇沈杜公路118号2幢104室",
                    tel: "021-58089508"
                },
                {
                    id: 17,
                    name: "东风南方保险代理有限公司 茂名分公司",
                    addr: "茂名市茂南区环市西路文岭村委会12巷1号厂房101室",
                    tel: "0668-33936000"
                },
                {
                    id: 18,
                    name: "东风南方保险代理有限公司 湖北分公司",
                    addr: "湖北省武汉市蔡甸区沌口小区海天汽配大世界西区29栋158号3楼",
                    tel: "027-84851699"
                },
                {
                    id: 19,
                    name: "东风南方保险代理有限公司 广西分公司",
                    addr: "柳州市柳南区广西汽车贸易园汇轮路3号柳州航盛航宇汽车销售服务有限公司二楼办公室",
                    tel: "0772-2805355"
                }
            ]
        };
    },
    methods: {
        headerstyle() {
            return "font-size: 0.67rem;font-weight: normal;background-color:#FAFAFA;color: #666666;";
        },
        cellStyle() {
            return "font-size: 0.53rem;color: #666666;";
        },
        changehb() {
            // < target="	_blank" href="http:localhost:8080/#/informationhb">
            window.open(`${process.env.VUE_APP_ORG}informationhb`, '_blank')
        }
    }
};
</script>

<style lang="less" scoped>
.ibr {
    margin-top: .73rem;

    .table-a {
        text-decoration: underline;
        color: #FF9600;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Information/branch.vue